export const STORE_VIEW_MAP = {
    INDICATORS: 'indicators',
    PERFECT_STORE: 'perfect_store',
    EXECUTION: 'execution',
    VOUCHERS: 'vouchers',
}
